// extracted by mini-css-extract-plugin
export var modal = "_60-0";